import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Card, Heading } from '@grupoboticario/flora-react'
import { applyTrackingLocale, readRememberedLocale, translateForLocale } from '../config/i18n'

const Expired = () => {
  const { state } = useLocation()
  const locale = state?.locale ?? readRememberedLocale()

  useLayoutEffect(() => {
    if (locale) applyTrackingLocale(locale)
  }, [locale])

  return (
    <Card css={{ width: '100%', marginTop: '20px', padding: '32px', boxShadow: '0px 4px 20px 0px #0000001F' }}>
      <Heading as="h1" css={{ fontSize: '32px', lineHeight: '36px', fontWeight: 500, padding: '5px 0' }}>
        {translateForLocale(locale, 'expiredMsg')}
      </Heading>
    </Card>
  )
}

export default Expired
